import { Amplify } from 'aws-amplify'
import { createRoot } from 'react-dom/client'
import App from './App'
import 'reset-css'
import 'ui/src/common/css/fonts.css'
import 'ui/src/common/css/print.css'

const container = document.getElementById('root')
const root = createRoot(container)

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || '',
    },
  },
})

root.render(<App />)
